// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6fe5a3bc","239":"e466e99e","455":"a2d96ce0"}[chunkId] + ".chunk.js";
};